import { V, S } from "src/shared-styles";

export default {
  V,
  S,
};
